<template>
  <div>
    <CRow class="justify-content-center mb-5">
      <CCol md="8">
        <CCardGroup>
          <CCard class="p-4">
            <CCardBody>
              <CForm class="text-center">

                <img src="@/assets/logo.svg" height="150px"/>
                <h1>{{content.title.filter( item => { return (item.key == lang) })[0].value}}</h1>
                <p class="text-muted">{{content.subTitle.filter( item => { return (item.key == lang) })[0].value}}</p>
                <CInput
                    placeholder="Username"
                    autocomplete="username email"
                >
                  <template #prepend-content><CIcon name="cil-user"/></template>
                </CInput>
                <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                >
                  <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                </CInput>
                <CRow>
                  <CCol  class="text-right">
                    <CButton color="danger" class="px-4">LOGIN</CButton>
                  </CCol>
                  <!--                  <CCol col="6" class="text-right">-->
                  <!--                    <CButton color="link" class="px-0">Forgot password?</CButton>-->
                  <!--                    <CButton color="link" class="d-lg-none">Register now!</CButton>-->
                  <!--                  </CCol>-->
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
          <CCard
              color="primary"
              text-color="white"
              class="d-md-down-none bg-style1"
              body-wrapper
          >
            <CCardBody class="ql-editor">
              <div v-html="content.description.filter( item => { return (item.key == lang) })[0].value"></div>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="5">
        <CRow>
          <CCol>
            <CCard>
              <CCardBody>
                <CRow>
                  <CCol>
                    <CInput
                        label="Start Date"
                        type="datetime-local"
                        v-model="content.startDate"
                    >
                      <template #prepend>
                        <CButton color="secondary">
                          <CIcon name="cil-calendar"/>
                        </CButton>
                      </template>
                    </CInput>
                  </CCol>
                  <CCol>
                    <CInput
                        label="End Date"
                        type="datetime-local"
                        v-model="content.endDate"
                    >
                      <template #prepend>
                        <CButton color="secondary">
                          <CIcon name="cil-calendar"/>
                        </CButton>
                      </template>
                    </CInput>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <MultiLanguage caption="Title" :items="content.title" />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <MultiLanguage caption="SubTitle" :items="content.subTitle" />
<!--                    <CInput-->
<!--                        label="SubTitle"-->
<!--                        type="text"-->
<!--                        v-model="content.subTitle"-->
<!--                    >-->
<!--                    </CInput>-->
                  </CCol>
                </CRow>
                <CRow>
                  <CCol >
<!--                    <quill-editor class="mb-3 mt-3" :content="content.message" @change="onEditor"/>-->
                    <MLEditor caption="Description" :items="content.description" />
                  </CCol>

                </CRow>
                <CRow>
                  <CCol  class="text-right">
                    <CButton color="success" class="px-4" @click="onSave">{{(content._id == null?"CREATE":"UPDATE")}}</CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
      <CCol col="12" md="7">
        <CCard>
          <CCardBody>
            <CDataTable
                tableFilter
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :items="items"
                :fields="fields"
                items-per-page-select
                :items-per-page="small ? 10 : 50"
                :dark="dark"
                pagination
                sorter

            >
              <template #no="{item,index}">
                <td @click="toggleDetails(item, index)">
                  {{index+1}}
                </td>
              </template>

              <template #startDate="{item,index}">
                <td> {{moment(item.startDate).format("YYYY-MM-DD HH:MM:ss")}} </td>
              </template>

              <template #endDate="{item,index}">
                <td> {{moment(item.endDate).format("YYYY-MM-DD HH:MM:ss")}} </td>
              </template>

              <template ##="{item,index}">
                <td>
                  <CRow>
                    <CCol class="text-center">
                      <!--                      <CButton size="sm" color="info" variant="ghost"  >-->
                      <!--                        <CIcon name="cil-settings"/>-->
                      <!--                      </CButton>-->
                      <CButton size="sm" color="info" variant="ghost" @click="onSelect(item)" >
                        <CIcon name="cil-pencil" />
                      </CButton>
                    </CCol>
                  </CRow>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import SearchEduction from "@/projects/components/Util/SearchEduction";
import MultiLanguage from "@/projects/components/Util/MultiLanguage";
import MLEditor from "@/projects/components/Util/MLEditor";
Vue.use(VueQuillEditor)

export default {
  name: 'ConfigLogin',
  components: {MLEditor, MultiLanguage, SearchEduction},
  props: {
    // items: Array,
    fields: {
      type: Array,
      default () {
        return [
          { key: 'no',label:'No'},
          { key: 'startDate',label:'StartDate'},
          { key: 'endDate',label:'EndDate'},
          { key: '#',label:'#' },

        ]
      }
    },
    caption: {
      type: String,
      default: 'User Accounts'
    },
    disable: {
      type: Boolean,
      default: false
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {
      horizontal: { label:'col-3', input:'col-9' },
      options: [{ label: "1", value:{cpu:2,mem:"50 GB", ram:"8 GB"}}],

    }
  },

  mounted () {
  },

  created () {
    this.onInit()
  },

  beforeDestroy () {

  },

  methods: {
    onInit(){
      // this.$store.dispatch("config/configLogin")
    },

    onEditor(html, text, quill) {
      this.content.message = html.html
    },

    onSave(){
      if(this.content._id == null){
        this.$store.dispatch("config/createLogin", this.content)
      }else{
        this.$store.dispatch("config/updateLogin", this.content)
      }
    },


    //
    onSelect(item){
      delete item.__v
      this.$store.commit("config/content",item)
    }

  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
      content: "config/content",
      items: "config/item",
    })
  },

  watch: {
    content(value){
    }
  }

}
</script>
<style>

</style>
